import ImageMediaData from 'app/Components/Media/Image/ImageMediaData';

/**
 * Image added as a block, render identical as a normal image.
 */
export default class ImageMediaDataBlock extends ImageMediaData {}